import { snapLoginConstants } from "../constants/snapLoginConstants"

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null
}

export const snapLoginState = (state = initialState, action) => {
  switch (action.type) {
    case snapLoginConstants.SNAP_LOGIN_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        data: null
      }
    case snapLoginConstants.SNAP_LOGIN_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        error: null,
        data: action.payload
      }
    case snapLoginConstants.SNAP_LOGIN_ERROR:
      return {
        ...state,
        success: false,
        loading: false,
        error: action.payload,
        data: null
      }
    default:
      return state
  }
}
